import Input2 from './input-2/Input2';
import { Controller } from 'react-hook-form';
import TextareaAutosize from 'react-autosize-textarea';
import styles from './input.module.less';

const TextArea = ({ inputRef, fieldName, className, ...props }) => (
    <Input2
        {...props}
        fieldName={fieldName}
        className={[styles.textArea, className].join(' ')}
        inputCreator={(inputProps, control) => {
            if (fieldName && control) {
                return (
                    <Controller
                        name={fieldName}
                        control={control}
                        render={({ field: { onChange, onBlur, name, value, ref } }) => (
                            <TextareaAutosize
                                {...inputProps}
                                onChange={onChange}
                                innerRef={ref}
                                defaultValue={value}
                                name={name}
                                onBlur={onBlur}
                                ref={ref}
                            />
                        )}
                    />
                );
            }
            return <TextareaAutosize ref={inputRef} {...inputProps} />;
        }}
    />
);

export default TextArea;
